import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ProjectConfigurationService } from './project-configuration.service';
import { ProgressService } from './progress.service';

@Injectable({
  providedIn: 'root'
})
export class ReactionForcesService {
  private http = inject(HttpClient);
  private projectConfig = inject(ProjectConfigurationService);
  private progressService = inject(ProgressService);

  public reactionForcesAvailable = false;
  public reactionForces?: { id: string; x: number; y: number; z: number }[][];

  public async getReactionForces(): Promise<void> {
    try {
      if (this.projectConfig.project.optimization?.reaction_force) {
        this.progressService.updateTaskProgress('reaction-forces', 50, 'Loading reaction forces...');

        this.reactionForces = (await lastValueFrom(
          this.http.get(this.projectConfig.project.optimization.reaction_force)
        )) as typeof this.reactionForces;
        this.reactionForcesAvailable = true;

        this.progressService.completeTask('reaction-forces', 'Reaction forces loaded');
      }
    } catch (e) {
      this.reactionForcesAvailable = false;
    }
  }
}
